module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeShow),
      expression: "codeShow"
    }],
    staticClass: "newrank-code-content"
  }, [_c('div', {
    staticClass: "newrank-code-box"
  }, [_c('p', {
    staticClass: "newrank-code-title"
  }, [_vm._v(_vm._s(_vm.codeTitle))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "newrank-code"
  }, [_c('img', {
    attrs: {
      "src": _vm.headImg(_vm.codeImg, 'code'),
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.tips))])]), _vm._v(" "), _c('div', {
    staticClass: "newrank-code-close",
    on: {
      "click": function($event) {
        return _vm.closePop()
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeShow),
      expression: "codeShow"
    }],
    staticClass: "mask"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "code-line"
  }, [_c('div', {
    staticClass: "circle circle-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "dashed-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle circle-right"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31a0242c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/popup.vue
// module id = 246
// module chunks = 45